import { useSelector, useDispatch, useStore } from "react-redux";
import { useMouseHover } from "../../../hooks/useMouseHover";
import { PageModel } from "../../../models/PageModel";
import { StoreState } from "../../../models/states/StoreState";
import useStyles from "./FlowPanel.styles";
import FlowQuestion from "./FlowQuestion";
import { navigationBranchTo, navigationPreviousPage } from "../../../redux/actions";

interface Props {
    page: PageModel;
    showBlockName?: boolean;
    isFirst?: boolean;
    active?: boolean;
    simulated?: boolean;
    completed?: boolean;
}

export default function FlowPage({
    page,
    showBlockName,
    isFirst,
    active,
    simulated,
    completed,
}: Props) {
    const [hovered, pointerHandlers] = useMouseHover();
    const classes = useStyles({
        selected: hovered,
        simulated: !!simulated,
        active: !!active,
    } as any);
    const store = useStore<StoreState>();
    const dispatch = useDispatch();
    const blockName = useSelector(
        (state: StoreState) => state.interview.navigation?.randomizedBlocks[page.blockIndex]?.name,
    );

    function navigateToPage() {
        if (simulated && page.questions?.[0])
            dispatch(
                navigationBranchTo({
                    destination: page.questions[0].name,
                    isPreviewNavigation: true,
                }),
            );
        if (completed) {
            const { history } = store.getState().interview.navigation;
            const historyIndex = history.indexOf(page);
            if (historyIndex === -1) {
                return;
            }
            const pagesFromLast = history.length - historyIndex;
            for (let i = 0; i < pagesFromLast; i++) {
                dispatch(navigationPreviousPage());
            }
        }
    }

    return (
        <>
            <div className={classes.flowPage} data-active={active || undefined}>
                {showBlockName && (
                    <div className={classes.blockStart}>
                        <span>{blockName}</span>
                    </div>
                )}
                {!isFirst && !showBlockName && (
                    <div className={classes.pageBreak}>
                        <span>Page Break</span>
                    </div>
                )}
                {page.questions?.map((question, questionIndex) => (
                    <FlowQuestion
                        question={question}
                        firstOfPage={questionIndex === 0}
                        key={question.id}
                        active={active}
                        simulated={simulated}
                        completed={completed}
                        selected={hovered}
                    />
                ))}
                {!active && (
                    <div
                        className={classes.flowPageSelectArea}
                        {...pointerHandlers}
                        onClick={navigateToPage}
                    />
                )}
            </div>
        </>
    );
}
